import { Table } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const ViewHolidays = ({ fullData }: any) => {
  const [holidays, setHolidays] = useState<any[]>([]);
  const columns: any = [
    { title: "Holiday Name", dataIndex: "holidayName", key: "holidayName" },
    {
      title: "Holiday Date",
      dataIndex: "holidayDate",
      key: "holidayDate",
      render: (text: any) => {
        return text && dayjs(text).format("DD-MMM-YYYY");
      },
    },
  ];
  useEffect(() => {
    if (fullData) {
      const holidays = fullData.calendarHolidays || [];
      setHolidays(holidays);
    }
  }, [fullData]);
  return (
    <>
      <div className="mt-2">
        <Table
          dataSource={holidays}
          columns={columns}
          bordered
          size="middle"
          scroll={{
            x: 1100,
          }}
        />
      </div>
    </>
  );
};

export default ViewHolidays;
